<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/community_manager/wip"
      *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Wip</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" routerLink="/designer/wip"
      *ngIf="role=='designer'">Wip</span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']"
      [queryParams]="{lead_status: lead_status}"
      *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']"
      [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer' && lead_details">Lead </span>
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;"
      *ngIf="lead_details && lead_details.user_reference">{{lead_details.user_reference.name}} -
      {{lead_details.project_details.name}}</span>
  </div>
</div>
<div class="rk-ui-notification"  *ngIf="successalert" style="z-index: 10000 !important">
  <span id="notificationMessageText">{{successMessage}}</span>
  <a class="close rk-linknotification" (click)="successalert=false">×</a>
</div>
<div class="rk-ui-notification err"  *ngIf="erroralert">
  <span id="notificationMessageText">{{errorMessage}}</span>
  <a class="close rk-linknotification" (click)="erroralert=false">×</a>
</div>
<div class="row px-4">
  <app-shared-top-menu [lead_id]='lead_id' [lead_details]='lead_details' [lead_status]='lead_status'
    [payment_tab]='"active"'></app-shared-top-menu>
  <div class="col-12">
    <div class="row mb-5">
      <div class="col-md-12 bg-white pb-3">
        <!-- Amount Details -->
        <div class="row">
        <div class="col-md-4 mt-3">
        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Order Booking Actual Date : </span>
          <span class="mb-0">{{order_booking_actual | date:'dd/MM/yyyy'}}</span>
        </div>

        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Order Confirmation Actual Date : </span>
          <span class="text-center mb-0">{{order_confirmation_actual | date:'dd/MM/yyyy'}}</span>
        </div>

        <div class="pt-1">
          <span class="mb-0" style="color: #8d0528; font-size: 14px;">Estimated Handover Date : </span>
          <span class="text-center mb-0">{{estimated_handover | date:'dd/MM/yyyy'}}</span>
        </div>
        </div>
        <div class="col-md-8">
        <div class="d-flex mt-3">
          <div class="amoutDetailsCard pt-1 text-center">
            <p class="mb-0">Total Approved Amount : </p>
            <p class="text-center mb-0">{{unutilized_amount | number : '1.0-0'}}</p>
          </div>

          <div class="amoutDetailsCard text-center pt-1 ml-1" style="width: 166px;">
            <p class="mb-0">Unutilized Amount at 10% : </p>
            <p class="text-center mb-0">{{amountAdded_10 | number : '1.0-0'}}</p>
          </div>

          <div class="amoutDetailsCard text-center pt-1 ml-1" style="width: 166px;">
            <p class="mb-0">Unutilized Amount at 40% : </p>
            <p class="text-center mb-0">{{amountAdded_40 | number : '1.0-0'}}</p>
          </div>

          <div class="amoutDetailsCard text-center pt-1 ml-1" style="width: 166px;">
            <p class="mb-0">Unutilized Amount at 50% : </p>
            <p class="text-center mb-0">{{amountAdded_40 | number : '1.0-0'}}</p>
          </div>
        </div>
        </div>
        </div>
        <div class="row">
          <div class="col-md-5">
            <ul class="nav nav-tabs ss-nav-tabs same-line" id="myTab" role="tablist">
              <li class="nav-item">
                <a class="nav-link active addCursor text-center " (click)="getSet('pre_10_percent')"
                  [ngClass]="{'active': selectedSet == 'pre_10_percent'}">Initial Payment</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active addCursor text-center" (click)="getSet('10_50_percent')"
                  [ngClass]="{'active': selectedSet == '10_50_percent'}">40% Payment</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active addCursor text-center" (click)="getSet('100_percent')"
                  [ngClass]="{'active': selectedSet == '100_percent'}">Final 50% Payment</a>
              </li>
            </ul>
          </div>

          <div class="col-md-7 marginTop39px">
            <button
              *ngIf="role == 'designer' || role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager'"
              type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#paymentMapping"
              (click)="openPaymentMappingModal()">Map Payments</button>
            <button
              *ngIf="role == 'designer' || role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager'"
              type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#addPayment"
              (click)="openAddPaymentModal()">Add Payment </button>
            <button type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#paymentHistoryModal"
              (click)="getPaymentHistory()">Payment History </button>
              <button type="button" class="btn btn-pink bt-boq-3" data-toggle="modal" data-target="#accountDetailsModal"
              (click)="getAccountDetails()">Account Details</button>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <div class="tableDiv " *ngIf="approveList && approveList.length>0">
              <div class="table-responsive">
                <table class="table ">
                  <thead class="thead-dark">
                    <tr>
                      <th scope="col" class="firstTh">#</th>
                      <th scope="col">REFERENCE NUMBER</th>
                      <th scope="col">FINAL BOQ Value</th>
                      <th scope="col">PAID AMOUNT</th>
                      <th scope="col">BALANCE AMOUNT</th>
                      <th scope="col">PAYMENT</th>
                      <th scope="col">UNMAP</th>
                      <th class="">
                        <span *ngIf="selectedSet == 'pre_10_percent'">
                          REPORT CLOSURE
                        </span>

                        <span *ngIf="selectedSet == '10_50_percent'">
                          PUSH TO PRODUCTION
                        </span>

                        <span *ngIf="selectedSet == '100_percent'">
                          FINAL PAYMENT COMPLETION
                        </span>

                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let quotation of approveList; let i = index; " [attr.data-index]="i" class="box-list">
                      <td>{{ i +1 }}</td>
                      <td><a [routerLink]="['/lead/'+lead_id+'/project/'+project_id+'/boq_modular/'+quotation.id]"
                          class="a_hrefLink" routerLinkActive='active'>{{quotation.reference_number}}</a></td>
                      <td>₹ {{ quotation.total_amount  |  number : '1.0-0'}}</td>
                      <td>
                        <span
                          *ngIf="quotation.paid_amount != null">₹ {{ quotation.paid_amount |  number : '1.0-0' }}</span>
                        <span *ngIf="quotation.paid_amount == null">0</span>
                      </td>
                      <td>₹ {{ (quotation.total_amount -quotation.paid_amount)|  number : '1.0-0' }}</td>
                      <td>
                        <div class="d-flex"
                          *ngIf="quotation.closure_status != 'completed' && (selectedSet == 'pre_10_percent' || selectedSet == '10_50_percent')">
                          <div class="paidPercentageBlock mr-2">
                            {{ ((quotation.paid_amount/quotation.total_amount)*100) |  number : '1.2-2' }}%</div>
                             
                        </div>

                        <div class="d-flex"
                          *ngIf="quotation.closure_status != 'completed' && selectedSet == '100_percent'">
                          <div class="paidPercentageBlock mr-2">
                            {{ ((quotation.paid_amount/quotation.total_amount)*100) |  number : '1.2-2' }}%</div> 
                            <!-- <span 
                            (click)="cancelMapping(quotation.id)" class="pointerCurser"><i class="fa fa-ban text-danger"
                              style="font-size:24px"></i></span> -->
                              
                        </div>
                      </td>
                      <td>
                        <span
                            *ngIf="quotation.per_10_closure_reported_at == null && quotation.per_10_approved_at ==  null && quotation.paid_amount != null && selectedSet == 'pre_10_percent'"
                            (click)="cancelMapping(quotation.id)">
                            <i class="fa fa-ban text-danger"
                              style="font-size:24px"></i>
                            </span>
                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at ==  null && selectedSet == '10_50_percent'"
                            (click)="cancelMapping(quotation.id)">
                            <i class="fa fa-ban text-danger"
                              style="font-size:24px"></i>
                            </span>
                            <span  *ngIf="quotation.per_100_reported_at ==  null && selectedSet == '100_percent'"
                              (click)="cancelMapping(quotation.id)" class="pointerCurser">
                              <i class="fa fa-ban text-danger"
                                style="font-size:24px"></i>
                              </span>
                      </td>
                      <td style="display: inline-flex;">
                        <ng-container *ngIf="selectedSet == 'pre_10_percent'">
                          <ng-container *ngIf="role!='business_head'">
                            <span
                              *ngIf="quotation.per_10_closure_reported_at == null && quotation.per_10_approved_at ==  null && quotation.paid_amount != null"
                              data-toggle="modal" data-target="#closureModal" (click)="openClosureModal(quotation.id)"
                              class="pointerCurser closure_icon pb-2 pointerCurser pt-2 text-center bt-boq-final2">
                              <!-- <i class="fa fa-creative-commons" style="font-size:24px"></i> -->
                              Report Closure
                            </span>
                            <span
                              *ngIf="quotation.per_10_closure_reported_at != null && quotation.per_10_approved_at ==  null" class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                              <!-- <i
                                class="fa fa-warning text-danger" style="font-size:24px"></i> -->
                                BU Head to Action
                              </span>
                          </ng-container>

                          <span *ngIf="quotation.per_10_approved_at !=  null"><i class="fa fa-check text-success"
                              style="font-size:24px"></i></span>

                          <span
                            *ngIf="quotation.per_10_closure_reported_at != null && (role=='city_gm' || role == 'business_head') && quotation.per_10_approved_at ==  null"
                            (click)="acceptClosure(quotation.id)" class="bt-boq-success2 pointerCurser text-center mr-2 py-2">
                            Approve Closure
                          </span>
                          <span
                            *ngIf="quotation.per_10_closure_reported_at != null && (role=='city_gm' || role == 'business_head') && quotation.per_10_approved_at ==  null"
                            (click)="rejectClosure(quotation.id)" class="bt-boq-reject pointerCurser text-center py-2">
                            Reject Closure
                          </span>
                          <span
                            *ngIf="quotation.per_10_closure_reported_at == null && quotation.per_10_approved_at ==  null && quotation.paid_amount != null && (role == 'business_head') "
                            data-toggle="modal" data-target="#closureModal" (click)="openClosureModal(quotation.id)"
                            class="pointerCurser closure_icon pb-2 pointerCurser pt-2 text-center bt-boq-final2">
                            <!-- <i class="fa fa-creative-commons" style="font-size:24px"></i> -->
                            Report Closure
                          </span>
                        </ng-container>

                        <ng-container *ngIf="selectedSet == '10_50_percent'">
                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at == null && quotation.per_50_approved_at == null"
                            data-toggle="modal" data-target="#reqpushToprobModal"
                            (click)="openpushToproduction(quotation.id)" class="pb-2 pointerCurser pt-2 text-center bt-boq-final2">
                            <!-- <i class="fa fa-cogs"
                              style="font-size:24px"></i> -->
                              Push to Production
                            </span>
                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at != null && quotation.per_50_approved_at == null && (role == 'business_head')"
                            (click)="approvePushtoProduction(quotation.id)" class="bt-boq-success pb-1 pointerCurser pt-1 text-center mr-2">
                            Approve pushed to production
                          </span>
                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at != null && quotation.per_50_approved_at == null && (role == 'business_head')"
                            (click)="rejectPushtoProduction(quotation.id)" class="bt-boq pb-1 pointerCurser pt-1 text-center" style="background-color: red !important; border-radius: 6px;">
                            Reject pushed to production
                          </span>

                          <span *ngIf="quotation.per_50_approved_at != null">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </span>

                          <span
                            *ngIf="quotation.per_50_push_to_production_reported_at != null && quotation.per_50_approved_at == null && (role != 'business_head')" class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                            <!-- <i
                              class="fa fa-warning text-danger" style="font-size:24px">
                            </i> -->
                            BU Head to Action
                          </span>
                        </ng-container>


                      <!-- final payment completion start-->

                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <span
                            *ngIf="quotation.per_100_reported_at == null && quotation.per_100_approved_at == null"
                            data-toggle="modal" data-target="#finalpaymentselectionModel"
                            (click)="openFinalPaymentSelection(quotation.id)" class="pb-1 pointerCurser pt-1 text-center bt-boq-final" style="width: 178px !important;">
                            <!-- <i class="fas fa-certificate"></i> -->
                            <!-- <i class="fas fa-certificate"
                              style="font-size:24px"></i> -->
                            Final Payment Completion Confirmation
                            </span>
                          <span
                            *ngIf="quotation.per_100_reported_at != null && quotation.per_100_approved_at == null && (role == 'business_head')"
                            (click)="approveFinalPaymentSelection(quotation.id)" class="bt-boq-success pb-1 pointerCurser pt-1 text-center mr-2">
                            Approve Final Payment Completion
                          </span>

                          <span
                            *ngIf="quotation.per_100_reported_at != null && quotation.per_100_approved_at == null && (role == 'business_head')"
                            (click)="rejectFinalPaymentSelection(quotation.id)" class="bt-boq-reject2 pb-1 pointerCurser pt-1 text-center">
                            Reject Final Payment Completion
                          </span>

                          <span *ngIf="quotation.per_100_approved_at != null">
                            <i class="fa fa-check text-success" style="font-size:24px"></i>
                          </span>

                          <span
                            *ngIf="quotation.per_100_reported_at != null && quotation.per_100_approved_at == null && (role != 'business_head')" class="pb-2 pointerCurser pt-2 text-center" style="color: #8d0528;">
                            <!-- <i
                              class="fa fa-warning text-danger" style="font-size:24px"></i> -->
                            BU Head to Action
                            </span>
                        </ng-container>

                        <!-- end -->






                        <!-- Previous code -->
                        <!-- <div *ngIf="role == 'designer' || role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager'">
                        <label class="form-check-label" for="proposal{{quotation.id}}" *ngIf="selectedSet != '100_percent'">
                          <input
                            class="form-check-input boq-checkbox"
                            type="checkbox"
                            id="proposal{{quotation.id}}"
                            name="proposal{{quotation.id}}"
                            [checked]="quotation.checked" (change)="onCheckChange($event)" value="{{quotation.id}}" [disabled]='quotation.copied == true' >
                        </label>
                        <label class="form-check-label" for="proposal{{quotation.id}}" *ngIf="selectedSet == '100_percent'">
                          <input
                            class="form-check-input boq-checkbox"
                            type="checkbox"
                            id="proposal{{quotation.id}}"
                            name="proposal{{quotation.id}}"
                            [checked]="quotation.checked" (change)="onCheckChange($event)" value="{{quotation.id}}" [disabled]='quotation.per_100_true == true' >
                        </label>
                      </div>
                      <div *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager') &&  selectedSet == 'pre_10_percent'">
                        <input type="button" name="" class="btn btn-pink" value="Approve" (click) = "approveBoq(quotation.id)" *ngIf="!quotation.per_10_approved_by_id && quotation.is_have_approved_payments == true && quotation.ten_per_true == false" >
                      </div>
                      <div *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager') &&  selectedSet == '10_50_percent'">
                        <input type="button" name="" class="btn btn-pink" value="Approve" (click) = "approveBoq(quotation.id)" *ngIf="!quotation.per_50_approved_by_id && quotation.per_50_true == false && quotation.is_have_approved_payments == true" >
                      </div> -->
                        <!-- Previous code Ends -->
                      </td>
                    </tr>
                    <tr>
                      <td>
                        </td>
                        <td><b>Total</b></td>
                        <ng-container *ngIf="selectedSet != '100_percent'">
                        <td><b>₹ {{total_amunt_sum | number : '1.0-0'}}</b></td>
                        </ng-container>
                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <td><b>₹ {{total_sum_50 | number : '1.0-0'}}</b></td>
                        </ng-container>
                        <ng-container *ngIf="selectedSet != '100_percent'">
                        <td><b>₹ {{paid_amunt_sum | number : '1.0-0'}}</b></td>
                      </ng-container>
                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <td><b>₹ {{paid_sum_50 | number : '1.0-0'}}</b></td>
                        </ng-container>
                        <ng-container *ngIf="selectedSet != '100_percent'">
                        <td><b>₹ {{(total_amunt_sum - paid_amunt_sum) | number : '1.0-0'}}</b></td>
                      </ng-container>
                        <ng-container *ngIf="selectedSet == '100_percent'">
                          <td><b>₹ {{(total_sum_50 - paid_sum_50) | number : '1.0-0'}}</b></td>
                        </ng-container>
                      </tr>
                  </tbody>
                </table>
                <!-- <p>{{paymentForm.value | json}}</p> -->
              </div>
            </div>
          </div>
          <div class="col-md-12 not-found " *ngIf="approveList && approveList.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<!-- Modal create for payment -->
<div id="addPayment" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog  modal-lg" style="max-width:50% ;">


    <div class="modal-content  paymodal-change" >
      <div class="modal-header  paymodal-header-change">
        <h4 class="modal-title pay-modal-title-change" style="width: 100%;margin-left: 24px;;">Add Payment Details</h4>
        <div class="payiconbox">
          <button type="button" class="close close-icon" data-dismiss="modal" (click)="paymentReset()">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change pay-modal-change-body" >
        <ul class="nav nav-tabs ul-payment " role="tablist" >
          <li class="nav-item pay-tabs  " style="width: 50%;">
            <a class="nav-link pay-tabs pay-tabs-base active" data-toggle="tab" href="#addpayment" role="tab">
              <i class="now-ui-icons objects_umbrella-13"></i> Add Payment
            </a>
          </li>
          <li class="nav-item pay-tabs " style="width: 50%;">
            <a class="nav-link pay-tabs pay-tabs-base" data-toggle="tab" href="#profile" role="tab">
              <i class="now-ui-icons shopping_cart-simple"></i> Send Payment Request
            </a>
          </li>
        </ul>
        <div class="tab-content  mt-3 " style="padding-right: 20px;padding-left: 20px;">
          <div class="tab-pane active" id="addpayment" role="tabpanel">
        <div class="row">
          <div class="col-md-12">
            <form [formGroup]="paymentForm">
              <ng-container *ngIf="selectedSet != '100_percent'">
                <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Enter Paid Amount"
                  formControlName="amount">
              </ng-container>
              <ng-container *ngIf="selectedSet == '100_percent'">
                <input type="number" class="form-control mb-2" id="pending_amt" placeholder="Paid Amount"
                  formControlName="amount" (input)="checkPendingAmt($event.target.id)">
              </ng-container>

              <select formControlName="mode_of_payment" class="form-control mb-2" (change)="changePaymentMode($event)">
                <option value="" [selected]="true" disabled="true">Select Payment Mode</option>
                <option value="NEFT/RTGS">NEFT/RTGS</option>
                <option value="cheque">Cheque</option>
              </select>

              <input type="text" class="form-control mb-2 cheque-mode" placeholder="Bank Name" formControlName="bank">
              <input type="text" class="form-control mb-2 cheque-mode" placeholder="Branch Name"
                formControlName="branch">
              <label class="cheque-mode">Date of cheque</label>
              <input type="date" class="form-control mb-2 cheque-mode" formControlName="date_of_checque">
              <label class="cheque-mode">Upload Image*</label>
              <label class="neft-mode">Upload Image</label>
              <input type="file" class="form-control cheque-mode" formControlName="image" (change)="onChange($event)">
              <input type="file" style="margin-bottom: 1rem" class="form-control neft-mode" formControlName="image"
                (change)="onChange($event)">
              <label class="neft-mode">Transaction Number</label>
              <input type="text" class="form-control mb-2 neft-mode" placeholder="Enter Transaction Number" formControlName="transaction_number">
              <label class="neft-mode">Payment Date</label>
              <input type="date" class="form-control mb-2 neft-mode" formControlName="date">
              <button class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" (click)="savePayment()"
              [disabled]="!paymentForm.valid">Add Payment</button>
         
            </form>
            <pre>
            <!-- {{paymentForm.value | json}} -->
          </pre>
        </div>
          <div class="col-md-6">
            

          </div>


        </div>
          </div>
          <div class="tab-pane" id="profile" role="tabpanel">
            <div class="row">
              <div class="col-md-12">
            <form [formGroup]="sendpaymentForm" >
              <label >Enter Amount</label>
              <input type="text"  class="form-control mb-2" placeholder="Enter amount" formControlName="totalamount" appTwoDigitDecimaNumber [(ngModel)] ="totalAmount" onKeyPress="totalamount()"   >
              <p class="error" *ngIf="totalAmount > 200000">Amount should not be more than 2 lakhs</p>
              <label >Email</label>
              <input type="text" class="form-control mb-2 " formControlName="email" [(ngModel)]="LeadNumber"  >
              <p class="error" *ngIf="sendpaymentForm.controls.email.touched && sendpaymentForm.controls.email.errors && sendpaymentForm.controls.email.errors.pattern">Please Enter Valid Email Address</p>
              <label >Mobile Number</label>
              <input type="number" class="form-control mb-2 " formControlName="mobilenumber" [(ngModel)]="LeadMail"  onKeyPress="if(this.value.length==10) return false;" >
              <p class="error" *ngIf="sendpaymentForm.controls.mobilenumber.touched && sendpaymentForm.controls.mobilenumber.errors && sendpaymentForm.controls.mobilenumber.errors.pattern">Mobile No Should be At Least 10 Characters</p>
            
                <button class="btn  interalBtnColor addCursor mt-2" style="width:100% ;" 
                [disabled]="!sendpaymentForm.valid || totalAmount > 200000" (click)="sendapaymentrequest(sendpaymentForm.value)">Send Payment Request</button>
  
            </form>
            </div>
            </div>

             
          </div>
        </div>

      </div>

    </div>
  </div>
</div>

<!-- Modal end here -->

<!--Payment history modal starts-->
<div id="paymentHistoryModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="loading d-block justify-content-center" *ngIf="loader">
    <div class="spinner-border" style="color: #8d0528;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="modal-dialog modal-lg" style="max-width:90% ;">
    <div class="modal-content modal-change">
      <div class="modal-header modal-header-chng">
        <h4 class="modal-title modal-title-change">Payments History</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change p-4">
       
        <div class="row">
          <div class="col-md-12 p-0">
            <collapsible-table [type]="'accordion'" class="table Vborder" style="outline: none;border: none;">
              <thead class="thead-dark Vfont">
                <collapsible-table-row>
                  <th scope="col" class="firstTh">#</th>
                  <th scope="col">DATE/DATE OF CHEQUE</th>
                  <th scope="col">PAYMENT MODE</th>
                  <th scope="col">Date OF ADDING PAYMENTS</th>
                  <th scope="col">PAID AMT<br><span>(by customer)</span></th>
                  <th scope="col">TRANSACTION NUMBER</th>
                  <!-- <th scope="col">Cheque No / RTGS Slip</th> -->
                  <th scope="col">Finance Status </th>
                  <th scope="col">Finance Verification Date</th>
                  <th scope="col">PREVIEW UPLOADED IMAGE</th>
                  <th scope="col"></th>
                </collapsible-table-row>
              </thead>
              <tbody>
                <ng-container *ngFor="let history of payment_details_Arr; let i = index; " [attr.data-index]="i">
                  <collapsible-table-row style="box-shadow:1px 1px 7px 0px #dadada; border-radius: 10px;">
                    <td class="capitalize">{{ i +1 }}</td>
                    <td class="capitalize">
                      <span *ngIf="history.date">{{history.date | date}}</span>
                      <span *ngIf="history.date_of_checque">{{history.date_of_checque|date}}</span>
                    </td>
                    <td *ngIf="history.mode_of_payment != 'cheque' ">{{history.mode_of_payment| replaceChar}}</td>
                    <td *ngIf="history.mode_of_payment == 'cheque' ">{{history.mode_of_payment| uppercase}}</td>
                    <td class="capitalize">{{history.created_at|date}}</td>
                    <td class="capitalize">{{history.amount}}</td>
                    <td class="capitalize" style="min-width: 260px;" *ngIf="history.mode_of_payment == 'NEFT/RTGS' || history.mode_of_payment == 'hdfc' ">
                      {{history.transaction_number}}</td>
                    <td class="capitalize" *ngIf="history.mode_of_payment != 'NEFT/RTGS' && history.mode_of_payment !== 'hdfc'  ">N/A</td>
                    <td class="capitalize"> {{history.finance_status}} </td>
                    <td class="capitalize"> {{history.finance_approved_at| date }}</td>
                    <td class="capitalize text-center">
                      <a *ngIf="history.mode_of_payment == 'cheque' && history.image !='/images/original/missing.png'"
                        href="{{ history.image }}" target="_blank"
                        style="color: #8F0020;font-size: 20px; vertical-align: middle;"><i class="fas fa-image"></i></a>
                      <a *ngIf="history.mode_of_payment != 'cheque'  && history.image !='/images/original/missing.png'"
                        href="{{ history.image }}" target="_blank"
                        style="color: #8F0020;font-size: 20px;vertical-align: middle;"><i class="fas fa-image"></i></a>
                    </td>
                    <td class="capitalize" ><span *ngIf="history.finance_status=='Approved'" data-toggle="tooltip"
                        title="Click Here To Download and Share Payment Receipt." ><i class="fa fa-arrow-circle-down p-0"
                          aria-hidden="true" data-toggle="modal" data-target="#PaymentReceipt"
                          (click)="PaymentReceiptData(history.id,history,true)"
                          style="font-size: 24px;vertical-align: middle;"></i></span>
                        <span style="display: inline-block;width: 220px;" *ngIf="history.mode_of_payment == 'hdfc' && history.finance_status !=='Approved'"><a  class="btn btn-pink bt-boq" style="width: 100px;text-align: center;" (click)="sendsms(history)">Send SMS <br>to Customer</a>
                        <a  class="btn btn-pink bt-boq" style="width: 100px;text-align: center"(click)="sendemail(history)">Send Email <br>to Customer</a>
                        </span>
                        </td>
                        
                  </collapsible-table-row>
                  <collapsible-table-row-detail>
                    <table class="w-100">
                      <tr class="table-row">
                        <td scope="col">REF NO.</td>
                        <!-- <td scope="col">LAST EDITED ON</td>
                    <td scope="col">PRICE EXPIRY</td>
                    <td scope="col">STATUS</td> -->
                        <td scope="col">BOQ VALUE</td>
                        <td scope="" class="m-0 pr-0">APPORTIONED PAYMENT VALUE</td>
                      </tr>
                      <tr *ngFor="let payment of payment_details ">
                        <td class="capitalize">{{payment.boq_reference_number}}</td>
                        <!-- <td>{{payment.boq_updated_at | date:'dd MMMM, y @ h:mma'}}</td>
                    <td >{{payment.boq_expiration_date}}</td>
                    <td>{{payment.boq_status}}</td> -->
                        <td>{{payment.boq_total_amount}}</td>
                        <td>{{payment.approtioned_payment_value |  number : '1.2-2' }}</td>
                      </tr>
                    </table>
                  </collapsible-table-row-detail>
                </ng-container>
              </tbody>
            </collapsible-table>
          </div>
          <div class="col-md-12 not-found " *ngIf="payment_details_Arr && payment_details_Arr.length== 0">
            <div class="boq-img">
              <img src="../../../assets/img/desktop.png" style="height: 250px;width: 300px">
            </div>
            <p class=" pb-4" style="font-size: 21px;text-align: center;color: dimgray">Nothing to show...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--Payment history modal ends-->

<!-- Payment Receipt -->
<div id="PaymentReceipt" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <div class="modal-dialog" style="max-width: 34%;">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" style="margin-left: 105px;">Download Billing Receipt</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="PaymentModalHide();">&times;</button>
      </div>
      <div class="modal-body">
        <form class="personal-data-form" [formGroup]="ReceiptForm">
          <div class="">
            <label class="d-flex">Customer Name:
              <input class="form-control" placeholder="Customer name" type="text" formControlName="customer_name"
                style="margin-left:7px;" readonly>
            </label>
          </div>
          <div class="">
            <label class="d-flex">Amount:
              <input class="form-control" placeholder="Amount" type="number" formControlName="amount"
                style="margin-left:37px;" readonly>
            </label>
          </div>
          <div class="" *ngIf="this.details">
            <label class="d-flex">Date:
              <input [owlDateTime]="dt8" [owlDateTimeTrigger]="dt8" placeholder="Enter Date" formControlName="date"
                class="form-control" style="margin-left:61px;" readonly>
              <owl-date-time #dt8 [pickerType]="'calendar'" disabled></owl-date-time>
            </label>
          </div>
          <div class="" *ngIf="this.details && this.details.mode_of_payment == 'NEFT/RTGS'">
            <label class="d-flex">NEFT/RTGS Trx No:
              <input class="form-control" placeholder="RTGS Trx No" type="text" formControlName="rtgs_trx_no"
                style="margin-left:-10px;" readonly>
            </label>
          </div>
          <div class="" *ngIf="this.details && this.details.mode_of_payment == 'hdfc'">
            <label class="d-flex">HDFC Trx No:
              <input class="form-control" placeholder="HDFC Trx No" type="text" formControlName="hdfc_tx_no" [(ngModel)] ="hdfctxno"
                style="margin-left:-10px;" readonly>
            </label>
          </div>
          <div class="" *ngIf="this.details && this.details.mode_of_payment == 'cheque'">
            <label class="d-flex">Bank:
              <input class="form-control" placeholder="Bank" type="text" formControlName="bank"
                style="margin-left:58px;" readonly>
            </label>
            <label class="d-flex">Branch:
              <input class="form-control" placeholder="Branch" type="text" formControlName="branch"
                style="margin-left: 45px;" readonly>
            </label>
          </div>
        </form>
        <div class="col-12 mt-5 text-right">
          <i class="fa fa-arrow-circle-down p-0 mr-4 addCursor" (click)="getReceipt('')" style="font-size: 24px"
            data-toggle="tooltip" title="Click Here To Download Payment Receipt."></i>
          <i class="fas fa-share addCursor" (click)="share('share')" style="font-size: 24px" data-toggle="tooltip"
            title="Click Here To Share Payment Receipt."></i>
        </div>
      </div>
    </div>
  </div>
</div>



<!-- Payment Maping -->
<div class="modal" id="paymentMapping">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Payment Maping</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body" style="height:20rem; overflow:scroll">
        <div class="pt-2">
        </div>
        <div class="row mb-3">
          <div class="col-md-5 pt-2">
            <span>
              Unutilized Amount At
              <span *ngIf="selectedSet == 'pre_10_percent'">
                10%
              </span>

              <span *ngIf="selectedSet == '10_50_percent'">
                40%
              </span>

              <span *ngIf="selectedSet == '100_percent'">
                50%
              </span>
            </span>
            :{{use_total_amt}}
          </div>
          <div class="col-md-2"><button class="btn btn-pink bt-boq" style="font-size: 14px;"
              (click)="mapProporitionately()">Map Proporitionately</button></div>
          <div class="col-md-2 pt-1"><input class="inputBorder clearamount" type="number" id="unutilizePayment"
              (input)="getUnutilAmount($event.target.value)" /></div>
          <div class="col-md-2 pt-1"><input class="inputBorder clearPerc" type="text" id="unutilizePercentage"
              value="0%" disabled /></div>
        </div>
        <ng-container *ngIf="selectedSet == 'pre_10_percent'">
          <div class="row" *ngFor="let item of approveList">
            <ng-container *ngIf="item.per_10_approved_at == null && item.per_10_closure_reported_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input class="inputBorder clearamount pl-1" type="number" id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" value=0 /></div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" id="boqPercent{{item.id}}"
                  value="0%" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedSet == '10_50_percent'">
          <div class="row" *ngFor="let item of approveList">
            <ng-container *ngIf="item.per_50_push_to_production_reported_at == null && item.per_50_approved_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input class="inputBorder clearamount pl-1" type="number" id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" value=0 /></div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" value="0%"
                  id="boqPercent{{item.id}}" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedSet == '100_percent'">
          <div class="row" *ngFor="let item of approveList">
            <ng-container  *ngIf="item.per_100_reported_at == null && item.per_100_approved_at == null">
              <div class="col-md-2">
                <p>{{item.reference_number}}</p>
              </div>
              <div class="col-md-4 d-flex">
                <p>{{item.total_amount |  number : '1.2-2'}}</p>
                <p class="ml-1" *ngIf="item.paid_amount != null">Mapped Amount:
                  <span>
                    {{ item.paid_amount |  number : '1.2-2' }}
                    ({{ ((item.paid_amount/item.total_amount)*100) |  number : '1.2-2' }}%)
                  </span>
                </p>
              </div>
              <div class="col-md-3"><input placeholder="Enter Amount" class="inputBorder clearamount pl-1" type="number"
                  value=0 id="boqPayment{{item.id}}"
                  (input)="getBoqPayAmount($event.target.value,item.total_amount,item.id)" />
              </div>
              <div class="col-md-3"><input class="inputBorder pl-1 clearPerc" type="text" value="0%"
                  id="boqPercent{{item.id}}" disabled /></div>
            </ng-container>
          </div>
        </ng-container>
      </div>

      <!-- Modal footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-pink bt-boq" (click)="submitMapPayment()">Submit</button>
      </div>
    </div>
  </div>
</div>

<!--Account Details Modal-->
<div id="accountDetailsModal" class="modal fade" role="dialog" data-keyboard="false" data-backdrop="static">
  <!-- <div class="vertical-alignment-helper"> -->
  <div class="modal-dialog modal-dialog-centered" style="max-width: 52%;">
    <div class="modal-content modal-change">
      <div class="modal-header">
        <h4 class="modal-title">Account Details</h4>
        <div class="iconbox">
          <button type="button" class="close close-icon" data-dismiss="modal">&times;</button>
        </div>
      </div>
      <div class="modal-body modal-body-change p-4">
        <div class="row justify-content-center">
          <div class="col-md-10">
            <div class="row">   
              <div class="col-md-6">Customer Name:</div>
              <div class="col-md-6 detailscolor account_name mt-1" style="font-size: 13px;">{{accountdetails?.customer_name}}</div>
              </div>
         <div class="row">   
        <div class="col-md-6">Payment Mode:</div>
        <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.payment_mode}}</div>
        </div>
        <div class="row">   
          <div class="col-md-6">Account Name:</div>
          <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.account_name}}</div>
          </div>
          <div class="row">   
          <div class="col-md-6">Account Number:</div>
          <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.account_number}}</div>
          </div>  
          <div class="row">   
          <div class="col-md-6">IFSC Code:</div>
          <div class="col-md-6 detailscolor account_name mt-1">{{accountdetails?.ifsc_code}}</div>
          </div> 
          <div class="row">   
            <div class="col-md-6">Bank And Branch:</div>
            <div class="col-md-6 detailscolor account_name mt-1">{{bankAndbrach}}</div>
            </div>
        </div>
        
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
</div>
<!--Account Details Modal Ends Here-->

<!-- The Closure Modal -->
<div class="modal" id="closureModal">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Closure Report</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to report closure? The action can not be Undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="closureBoq()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>


<!-- The Closure Modal -->
<div class="modal" id="reqpushToprobModal">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Push to production</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to ask for push to production? The action can not be Undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="pushToproduction()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>




<!-- The Final Payment selection-->
<div class="modal" id="finalpaymentselectionModel">
  <div class="modal-dialog" style="max-width: 37%;">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Final Payment Completion</h4>
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>

      <!-- Modal body -->
      <div class="modal-body">
        Are you sure you want to ask for final payment completion? The action can not be Undone
      </div>

      <!-- Modal footer -->
      <div class="border-0 justify-content-center modal-footer">
        <button type="button" class="btn btn-success" data-dismiss="modal" (click)="FinalPaymentSelectionYes()" style="width: 67px;">Yes</button>
        <button type="button" class="btn btn-pink bt-boq" data-dismiss="modal" style="width: 67px;">No</button>
      </div>
    </div>
  </div>
</div>

<div class="loading d-block justify-content-center" *ngIf="loader">
  <div class="spinner-border" style="color: #8d0528;" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/lead/payments/payments.component.html